import React from 'react';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = React.useState(localStorage.getItem('sidebar_collapsed') === 'true');

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem('sidebar_collapsed', newState);
  };

  return (
    <div className={`layout ${isCollapsed ? 'collapsed' : ''}`}>
      <Sidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <div className="main">
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
